import { TVehicle } from "types";

interface IModellReducer {
  vehicles: TVehicle[];
  filter: any;
}

const ModellReducer = ({ vehicles, filter }: IModellReducer) => {
  if (!(filter.modell && filter.modell.length)) return vehicles;
  const {
    modell: modellFilter,
    marke: markeFilter,
    modell_gruppe: modellGruppeFilter,
  } = filter;
  return vehicles.filter(({ modell }) => {
    return (
      modellFilter.includes(modell.id) ||
      markeFilter.includes(modell.marke?.id) ||
      modellGruppeFilter.includes(modell.modell_gruppe?.id)
    );
  });
};

export default ModellReducer;
